/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Invoice State
 * @export
 * @enum {string}
 */
export enum InvoiceState {
    PENDING = 'PENDING',
    SUCCESSFUL = 'SUCCESSFUL',
    REPORTED = 'REPORTED'
}


export function InvoiceStateFromJSON(json: any): InvoiceState {
    return InvoiceStateFromJSONTyped(json, false);
}

export function InvoiceStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceState {
    return json as InvoiceState;
}

export function InvoiceStateToJSON(value?: InvoiceState | null): any {
    return value as any;
}

